import { initCoralogix } from 'monitoring/coralogix';
initCoralogix('widget');
var load = function () {
    import(/* webpackChunkName: "Converse" */ './widget-initiator').then(function (module) {
        module.ConverseInit();
    });
};
load();
export default load;
